import { createSlice } from '@reduxjs/toolkit'

export const loginSlice = createSlice({
  name: 'globals',
  initialState: {
      apiRoot: "https://demo-mag.azurewebsites.net"
  }
})

export default loginSlice.reducer